let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName].push(callback);

  return function unsubscribe() {
    if (!subscribers[eventName]) return;
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
    if (subscribers[eventName].length === 0) {
      delete subscribers[eventName];
    }
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => callback(data));
    return Promise.all(promises);
  } else {
    return Promise.resolve();
  }
}
